import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authToken = () => localStorage.getItem("wp_token");

export const thumbUrl = (classId) => `${API}/media/thumb/${classId}`;
export const videoUrl = (classId) => {
  const t = authToken();
  return `${API}/media/video/${classId}${t ? `?auth=${t}` : ""}`;
};

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return JSON.stringify(d);
};
